import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { Grid } from "@mui/material";
import LineLiffRedirect from "./pages/UniversalToLiffRedirect";
import Lineconnect from "./pages/Lineconnect";
import LineRichmenuOneLink from "./pages/LineRichmenuOneLink";
import Ecatalog from "./pages/Ecatalog";
import LineSticker from "./pages/LineSticker";
import ShortLinkResolve from "./pages/ShortLinkResolve";
import RedirectSpinner from "./components/RedirectSpinner";


import "./index.css";

/*
  /qr และ /link-admin ใช้ MUI เต็ม ๆ ถ้า import ตรงจะบวมเข้า bundle หลักเกือบ 200 kB
  ซึ่งทุก route redirect เดิมต้องโหลดตามไปด้วยทั้งที่ไม่ได้ใช้ จึงแยกเป็น chunk ต่างหาก
  ส่วน ShortLinkResolve ตั้งใจ import ตรง เพราะต้องเริ่มทำงานทันทีที่ผู้ใช้สแกน QR
*/
const QrStudio = lazy(() => import("./pages/QrStudio"));
const ShortLinkAdmin = lazy(() => import("./pages/ShortLinkAdmin"));
const UserAdmin = lazy(() => import("./pages/UserAdmin"));
const PartnerAdmin = lazy(() => import("./pages/PartnerAdmin"));

export default function App() {
  return (
    <>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          minWidth: "380px",
        }}
      >
        <Router>
          {/*<LoginLineLiff />*/}
          <Suspense fallback={<RedirectSpinner />}>
          <Switch>
            <Route path="/line-liff-redirect" component={LineLiffRedirect} />
            <Route path="/line-connect" component={Lineconnect} />
            <Route path="/line-connect/*" component={Lineconnect} />
            <Route path="/richmenu-onelink/:menuType/:position" component={LineRichmenuOneLink} />
            <Route path="/e-catalog" component={Ecatalog} />
            <Route path="/line-sticker/:ref" component={LineSticker} />

            {/*
              route ใหม่ต้องอยู่ต่อท้ายเสมอ
              <Switch> จับ route แรกที่ match แล้วหยุด การเพิ่มต่อท้ายจึงไม่แย่ path ของเดิม
              และ prefix /s /qr /link-admin ไม่ชนกับชื่อใดที่มีอยู่ (กฎข้อ 1)
            */}
            <Route path="/s/:code" component={ShortLinkResolve} />
            <Route path="/qr" component={QrStudio} />
            <Route path="/link-admin" component={ShortLinkAdmin} />
            <Route path="/user-admin" component={UserAdmin} />
            <Route path="/partner-admin" component={PartnerAdmin} />
            </Switch>
          </Suspense>
        </Router>
      </Grid>
    </>
  );
}
